import axios from "../axiosInstance";
import type {
  CreateLibraryModuleRequest,
  LibraryModule,
} from "@/modules/learningCenter/features/ModuleLibrary/types/libraryModule.types";

/**
 * Create a new library module
 */
export const createLibraryModule = async (
  data: CreateLibraryModuleRequest
): Promise<LibraryModule> => {
  const response = await axios.post<LibraryModule>(
    "/api/learning-center/module-library",
    data
  );
  return response.data;
};

export default createLibraryModule;
